module.exports = __webpack_public_path__ + "assets/45f5bbccabf4740fe165376719543b9b.png";